<template>
  <div class="page-title">
    <h1>{{ title }}</h1>
  </div>
</template>

<script>
  export default {
    name: 'PageHeader',

    props: ['title']
  }
</script>

<style lang="scss" scoped>
  .page-title {
    @apply bg-secondary py-7 mb-2;
    padding-left: 70px;
    margin-bottom: 70px;
    position: relative;

    &:after {
      content: '';
      position: absolute;
      width: 100%;
      height: 16px;
      left: 0;
      bottom: -16px;
      background: linear-gradient(to bottom, rgba(0,0,0,0.1) 0%,rgba(0,0,0,0) 100%);
    }

    h1 {
      @apply text-white uppercase leading-none mb-0 font-heading-secondary font-bold;
      font-size: 44px;
    }
  }

</style>
